import React, { ReactElement } from "react";
import Content from "./Content";

export default function Ul(props: any): ReactElement {
  return (
    <ul style={{ marginBottom: "10px" }}>
      <Content contentValue={props.children} />
    </ul>
  );
}
